import { gql } from '@apollo/client';
import { CartInfoPublic } from '../fragments';

export default gql`
  query checkoutCart($cartId: ID!) {
    checkoutCart(cartId: $cartId) {
      ...CartInfoPublic
    }
  }
  ${CartInfoPublic}
`;
